module.exports = __webpack_public_path__ + "img/sld.55ea4a14.jpg";